import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

export const isDisplayFieldOnRecordPreviewByDefault = (field: IField) =>
  field.hasFeature(FieldFeature.RECORD_PREVIEW_VISIBLE_BY_DEFAULT);
